import {Box, Typography} from "@mui/material";
import {useEffect, useState} from "react";
import {getSummaryReport} from "../http/reportsAPI";
import parse from 'html-react-parser';
import {MaterialReactTable} from "material-react-table";
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import dayjs from "dayjs";
import {fetchAppointmentCancellations} from "../http/appointmentCancellationsAPI";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";

const TABLE_CONFIG = {
    COMMON: {
        enableStickyHeader: true,
        enableFullScreenToggle: false,
        enableDensityToggle: false,
        localization: MRT_Localization_RU,
        muiTablePaperProps: {
            sx: {
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                width: '100%',
            },
        },
        muiTableContainerProps: {
            sx: {
                flex: 1,
                maxHeight: 520,
                overflow: 'auto',
            },
        },
    },
};

const Statistics = () => {
    const [reportText, setReportText] = useState('');
    const [error, setError] = useState('');

    const [data, setData] = useState([]);
    const [rowCount, setRowCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState({pageIndex: 0, pageSize: 25});
    const [sorting, setSorting] = useState([{id: 'createdAt', desc: true}]);
    const [columnFilters, setColumnFilters] = useState([]);
    const [globalFilter, setGlobalFilter] = useState('');


    useEffect(() => {
        getSummaryReport().then(res => {
            setReportText(res.summary)
        }).catch(e => {
            setError(e.message)
        });
    }, [])

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const query = {
                    page: pagination.pageIndex + 1,
                    limit: pagination.pageSize,
                    sortBy: sorting[0]?.id,
                    order: sorting[0]?.desc ? 'desc' : 'asc',
                    search: globalFilter,
                    ...Object.fromEntries(
                        columnFilters.map(({id, value}) => [id, value])
                    ),
                };
                const res = await fetchAppointmentCancellations(query);
                setData(res.data);
                setRowCount(res.total);
            } catch (e) {
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [pagination, sorting, columnFilters, globalFilter]);

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ru">
            <Typography variant="h5" gutterBottom>
                Статистика
            </Typography>
            {error ? <Typography variant="body1" color="error" gutterBottom>{error}</Typography> :
                (<pre>{parse(reportText)}</pre>)}

            <Box sx={{mt: 4}}>
                <Typography variant="h6" gutterBottom>
                    Отмены приёма
                </Typography>
                <MaterialReactTable
                    {...TABLE_CONFIG.COMMON}
                    columns={[
                        {accessorKey: 'user.name', header: 'Пациент'},
                        {accessorKey: 'user.phone', header: 'Телефон'},
                        {
                            accessorKey: 'createdAt',
                            accessorFn: (row) => new Date(row.createdAt),
                            header: 'Дата отмены',
                            filterVariant: 'date-range',
                            Cell: ({cell}) => dayjs(cell.getValue()).format('DD.MM.YYYY HH:mm'),
                        },
                        {
                            accessorKey: 'reason.name',
                            header: 'Причина',
                            Cell: ({row}) => row.original.reason?.name || row.original.reasonNameSnapshot || '—',
                        },
                        {accessorKey: 'comment', header: 'Комментарий'},
                        {accessorKey: 'doctorNameSnapshot', header: 'Врач'},
                        {accessorKey: 'branchNameSnapshot', header: 'Филиал'},
                        {
                            accessorKey: 'timeStartSnapshot',
                            header: 'Время приёма',
                            Cell: ({row}) => row.original.timeStartSnapshot ? dayjs(row.original.timeStartSnapshot).format('DD.MM.YYYY HH:mm') : '—',
                        },
                    ]}
                    data={data}
                    manualPagination
                    manualSorting
                    manualFiltering
                    rowCount={rowCount}
                    state={{
                        isLoading: loading,
                        pagination,
                        sorting,
                        columnFilters,
                        globalFilter,
                    }}
                    onPaginationChange={setPagination}
                    onSortingChange={setSorting}
                    onColumnFiltersChange={setColumnFilters}
                    onGlobalFilterChange={setGlobalFilter}
                    initialState={{
                        density: 'compact',
                        showColumnFilters: true,
                    }}
                />
            </Box>
        </LocalizationProvider>
    )
}

export default Statistics;